<template>
<div v-html="thetext">
</div>	
</template>

<script>
export default {

  name: 'CustomTextType',  
  props:["data"],
  data () {
    return {

    }
  },
  computed:{
  	thetext()
  	{
  		return this.getTheTranslation(this.data,"translation")
  	}
  }
}
</script>

<style lang="css" scoped>
</style>